export default __webpack_public_path__ + "static/media/buyImage.6f8a02eb.jpg";